var React = require('react');

function TemperatureUp (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256,278.5V112a112,112,0,0,0-224,0V278.5C12.3,303.19,0,334,0,368a144,144,0,0,0,288,0C288,334,275.7,303.09,256,278.5ZM144,448A79.87,79.87,0,0,1,96,304.19V112a48,48,0,0,1,96,0V304.19A79.87,79.87,0,0,1,144,448Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160,322.91V112a16,16,0,0,0-32,0V322.91a48,48,0,1,0,32,0ZM507.3,132.69l-80-96a16,16,0,0,0-22.63,0l-80,96C314.66,142.75,321.78,160,336,160h48V464a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V160h48C510.19,160,517.36,142.75,507.3,132.69Z","className":"fa-primary","key":2})]);
}

TemperatureUp.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = TemperatureUp;

TemperatureUp.default = TemperatureUp;
